<template>
  <header class="app-header">
    <div class="header-container">
      <div class="logo">
        <router-link to="/">
          <el-icon class="logo-icon"><Money /></el-icon>
          <span class="logo-text">Go Coin Identifier</span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { Money } from '@element-plus/icons-vue'

export default {
  name: 'AppHeader',
  components: {
    Money
  }
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  position: relative;
  z-index: 1001;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo a:hover {
  transform: scale(1.05);
}

.logo-icon {
  font-size: 2.5rem;
  color: #fdbb2d;
  margin-right: 15px;
  background: rgba(253, 187, 45, 0.15);
  padding: 10px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.logo-text {
  font-size: 2rem;
  font-weight: bold;
  background: linear-gradient(135deg, #fdbb2d, #b21f1f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .logo-text {
    font-size: 1.6rem;
  }
  
  .logo-icon {
    font-size: 2rem;
    padding: 8px;
  }
}
</style> 